import {mainQuery} from '@github-ui/react-core/future/main-query'
import {appShellAppBuilder} from '../config/app-builder'

export type AppShellLayoutResponse = {
  someField: string
}

export const appShellLayoutRoute = appShellAppBuilder.createQueryRouteConfig('appShellLayoutRoute', {
  path: '/',
  queries: [
    mainQuery<AppShellLayoutResponse>({
      queryDeps: () => ({pathname: '/_shell/layout'}),
    }),
  ],
})
